import React, { useRef, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import { a1, a2, a3, a4, a5, } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------- SEO helpers ---------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// Порядок атрибутов: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}



function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function ensurePreloadImage(src) {
  if (!src) return;
  const sel = `link[rel="preload"][as="image"][href="${src}"]`;
  if (!document.querySelector(sel)) {
    const l = document.createElement("link");
    l.rel = "preload";
    l.as = "image";
    l.href = src;
    document.head.appendChild(l);
  }
}

function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const HomePage = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

  // твоя функция — оставляю для совместимости
  function setMetaTag(name, content) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (element) {
      element.setAttribute("content", content);
    } else {
      element = document.createElement("meta");
      element.name = name;
      element.content = content;
      document.head.appendChild(element);
    }
  }

useEffect(() => {
  // ===== Прелоад важного изображения =====
  ensurePreloadImage(a1);

  // ===== Копирайтинг (EN → BN перевод уже есть) =====
  const titleEN = " HHBD — Bangladesh’s Best Online Casino for Real BDT Wins";
  const descEN =
    "Join HHBD, Bangladesh’s trusted casino platform! Play slots, live dealer tables & crash games with real BDT payouts. Enjoy 5-minute withdrawals via bKash or Nagad, 100% welcome bonuses, and nonstop Bangla-friendly gaming.";

  const titleBN = "HHBD — রিয়েল BDT জয়ের জন্য বাংলাদেশের সেরা অনলাইন ক্যাসিনো";
  const descBN =
    "বাংলাদেশের বিশ্বস্ত ক্যাসিনো প্ল্যাটফর্ম HHBD-তে যোগ দিন! আসল BDT পেমেন্টের মাধ্যমে স্লট, লাইভ ডিলার টেবিল এবং ক্র্যাশ গেম খেলুন। বিকাশ বা নগদের মাধ্যমে ৫ মিনিটের উত্তোলন, ১০০% স্বাগত বোনাস এবং ননস্টপ বাংলা-বান্ধব গেমিং উপভোগ করুন।";

  const keywordsEN =
    "HHBD, online casino Bangladesh, BDT casino, slots BD, crash game Bangladesh, live casino BD, real money casino, Bangla casino site";
  const keywordsBN =
    "HHBD ক্যাসিনো, অনলাইন ক্যাসিনো বাংলাদেশ, স্লট গেম বিডি, ক্র্যাশ গেম, রিয়েল মানি গেম, বাংলাদেশ ক্যাসিনো";

  const isBN = lang === "bn";

  // ===== ТИТУЛЫ ДОЛЖНЫ БЫТЬ В UPPERCASE (document/OG/Twitter) =====
  const pageTitle = (isBN ? titleBN : titleEN).toUpperCase(); // ✅ все обычные тайтлы в верхнем регистре
  const pageDesc = isBN ? descBN : descEN;                    // мета description: обычный регистр
  const pageKeywords = isBN ? keywordsBN : keywordsEN;        // мета keywords: обычный регистр

  // ===== Базовые <title> и meta =====
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaTag("description", pageDesc);        // обычный регистр
  setMetaTag("keywords", pageKeywords);       // обычный регистр

  // ===== URL-ы =====
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // ===== hreflang =====
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // ===== Canonical + hreflang (+ x-default) =====
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // ===== Open Graph (тайтл в UPPERCASE) =====
  const ogImage = toAbsoluteUrl(a1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);      // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc); // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? titleBN : titleEN); // alt — читаемый текст
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // ===== Twitter (полный блок; тайтл в UPPERCASE; добавлен twitter:url) =====
  const twitterSite = "@HHBD_official";     // замените на реальный @ при наличии
  const twitterCreator = "@HHBD_official";  // опционально
  const twitterImageAlt = isBN
    ? "HHBD – বাংলাদেশের আধুনিক অনলাইন ক্যাসিনো এবং স্পোর্টস বেটিং হাব যা প্রকৃত বাংলাদেশী টাকা পুরস্কার এবং তাৎক্ষণিক অর্থ প্রদান করে।"
    : "HHBD – Bangladesh’s modern online casino and sports betting hub offering real BDT rewards and instant payouts.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);       // ✅ UPPERCASE
  setMetaName("twitter:url", currentAbsUrl);     // ✅ добавлено
  setMetaName("twitter:description", pageDesc);  // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // Доп. пары (до 2-х)
  setMetaName("twitter:label1", isBN ? "বৈশিষ্ট্য" : "Features");
  setMetaName("twitter:data1", "Slots • Live Casino • Sports");
  setMetaName("twitter:label2", isBN ? "পেমেন্ট" : "Payments");
  setMetaName("twitter:data2", "bKash • Nagad • Rocket • Crypto");

}, [lang, pathname]);


  const faqRef = useRef();

  useEffect(() => {
    const root = faqRef.current;
    if (!root) return;

    const buttons = root.querySelectorAll(".zHHBD-faq__q");
    const answers = root.querySelectorAll(".zHHBD-faq__a");

    function closeAll() {
      answers.forEach((ans) => (ans.style.display = "none"));
      buttons.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    }

    buttons.forEach((btn, idx) => {
      btn.onclick = () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        closeAll();
        if (!expanded) {
          answers[idx].style.display = "block";
          btn.setAttribute("aria-expanded", "true");
        }
      };
    });

    closeAll();

    return () => {
      buttons.forEach((btn) => (btn.onclick = null));
    };
  }, [lang]);

  return (
    <>
<script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/";
      const siteName = "HHBD";

      // Берём уже объявленные у тебя значения (можно вынести наверх файла, вне useEffect):
      const titleEN = " HHBD — Bangladesh’s Best Online Casino for Real BDT Wins";
      const descEN =
        "Join HHBD, Bangladesh’s trusted casino platform! Play slots, live dealer tables & crash games with real BDT payouts. Enjoy 5-minute withdrawals via bKash or Nagad, 100% welcome bonuses, and nonstop Bangla-friendly gaming.";

      const titleBN = "HHBD — রিয়েল BDT জয়ের জন্য বাংলাদেশের সেরা অনলাইন ক্যাসিনো";
      const descBN =
        "বাংলাদেশের বিশ্বস্ত ক্যাসিনো প্ল্যাটফর্ম HHBD-তে যোগ দিন! আসল BDT পেমেন্টের মাধ্যমে স্লট, লাইভ ডিলার টেবিল এবং ক্র্যাশ গেম খেলুন। বিকাশ বা নগদের মাধ্যমে ৫ মিনিটের উত্তোলন, ১০০% স্বাগত বোনাস এবং ননস্টপ বাংলা-বান্ধব গেমিং উপভোগ করুন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps = (isBN ? descBN : descEN);

      // FAQ — синхронизируй с видимым контентом на странице (важно для соответствия)
const faqs = isBN
  ? [
      {
        q: "বাংলাদেশে HHBD–এ খেলা কি নিরাপদ?",
        a: "অবশ্যই — HHBD–এ আপনার সুরক্ষাই প্রথম। আমরা বৈধ আন্তর্জাতিক লাইসেন্সে পরিচালিত এবং ব্যক্তিগত ও আর্থিক ডেটা সুরক্ষায় অ্যাডভান্সড SSL এনক্রিপশন ব্যবহার করি। প্ল্যাটফর্মের প্রতিটি স্তর নির্মিত বিশ্বস্ত, নিরাপদ পরিবেশ তৈরি করতে — বিশেষত বাংলাদেশি প্লেয়ারদের জন্য।",
        icon: "🎰",
      },
      {
        q: "HHBD–এ টাকা ডিপোজিট ও উইথড্রও কীভাবে করব?",
        a: "ব্যাংকিং আমরা রেখেছি সরল ও সুবিধাজনক। HHBD জনপ্রিয় ও নিরাপদ স্থানীয় অপশন সাপোর্ট করে — যেমন bKash, Nagad, ব্যাংক ট্রান্সফার ও কার্ডস। ডিপোজিট প্রায় ইনস্ট্যান্ট প্রসেস হয়, আর উইথড্রও ফ্লো স্পিডের জন্য অপ্টিমাইজড — দ্রুতই জেতা অর্থ তুলতে পারবেন।",
        icon: "🆕",
      },
      {
        q: "ওয়েজারিং রিকোয়ারমেন্টস কী?",
        a: "ওয়েজারিং রিকোয়ারমেন্টস বোঝায় — কোনো বোনাস থেকে জেতা ক্যাশ–আউটের আগে আপনাকে কতবার টার্নওভার করতে হবে। যেমন, ৳১,০০০ বোনাসে ২০x মানে মোট ৳২০,০০০ বেট প্লেস করতে হবে আনলকের জন্য। আমরা শর্ত রাখি পরিষ্কার ও স্বচ্ছ — যাতে আপনি সবসময় জানেন কী আশা করবেন।",
        icon: "💳",
      },
      {
        q: "HHBD–এর গেমস ফেয়ার কি না, বুঝব কীভাবে?",
        a: (
          `<>
            HHBD ফেয়ার প্লের প্রতিশব্দ। সব টাইটেল — বিশেষ করে{" "}
            <Link to={getLangPath("/slots", lang)} className="zHHBD-faq__link">
              স্লটস
            </Link>{" "}
            — চলে সার্টিফায়েড RNG–এ, যাতে ফলাফল থাকে র‌্যান্ডম ও পক্ষপাতহীন। লাইসেন্সপ্রাপ্ত ক্যাসিনো গেমে হস্তক্ষেপ করে না — এতে লাইসেন্স ও রেপুটেশন দুটোই ঝুঁকিতে পড়ে। আমরা কেবল অডিটেড, শীর্ষ প্রোভাইডারের সঙ্গে পার্টনার করি।
          </>`
        ),
        icon: "🎁",
      },
      {
        q: "আমি কী ধরনের গেম খেলতে পারব?",
        a: (
          `<>
            আমাদের লাইব্রেরিতে রয়েছে অগণিত{" "}
            <Link to={getLangPath("/games", lang)} className="zHHBD-faq__link">
              গেমস
            </Link>{" "}
            — প্রতিটি রুচির জন্য। শত শত থিমড{" "}
            <Link to={getLangPath("/slots", lang)} className="zHHBD-faq__link">
              স্লটস
            </Link>{" "}
            উপভোগ করুন, লাইভ ক্যাসিনোতে রিয়েল হোস্টসহ Blackjack ও Roulette খেলুন, অথবা স্ট্র্যাটেজি–ফরোয়ার্ড ক্লাসিক টেবিল অপশন — Poker ও Baccarat — বেছে নিন।
          </>`
        ),
        icon: "🕹️",
      },
      {
        q: "খেলতে কি আলাদা অ্যাপ ডাউনলোড করতে হবে?",
        a: "না, ইন্সটল প্রয়োজন নেই। HHBD সাইট পুরোপুরি মোবাইল ব্রাউজারের জন্য অপ্টিমাইজড — চলতে চলতেই ইনস্ট্যান্ট অ্যাক্সেস। চাইলে আমরা একটি সুরক্ষিত অ্যান্ড্রয়েড অ্যাপও দিই — যারা ডেডিকেটেড অভিজ্ঞতা চান তাদের জন্য।",
        icon: "🔐",
      },
      {
        q: "আমার ব্যক্তিগত তথ্য কি গোপন রাখা হয়?",
        a: "হ্যাঁ। আমরা কড়া প্রাইভেসি পলিসি অনুসরণ করি — আপনার তথ্য কেবল ভেরিফিকেশন ও অ্যাকাউন্ট ম্যানেজমেন্টের জন্য ব্যবহৃত হয়। থার্ড–পার্টিকে ডেটা বিক্রি করি না, এবং আমাদের সিকিউরিটি স্ট্যাক আপনার তথ্য সবসময় সুরক্ষিত রাখতে ডিজাইন করা।",
        icon: "📱",
      },
    ]
  : [
      {
        q: "Is it safe to play at HHBD in Bangladesh?",
        a: "Absolutely — your protection comes first at HHBD. We operate under a valid international license and secure all personal and financial data with advanced SSL encryption. Every layer of the platform is designed to create a trustworthy, safe environment for Bangladeshi players.",
        icon: "🎰",
      },
      {
        q: "How can I deposit and withdraw Taka at HHBD?",
        a: "We keep banking simple and convenient. HHBD supports popular, secure local options — including e-wallets like bKash and Nagad, bank transfers, and cards. Deposits process instantly, and our withdrawal flows are optimized for speed so you can access winnings quickly.",
        icon: "🆕",
      },
      {
        q: "What are wagering requirements?",
        a: "Wagering requirements show how many times you must bet a bonus before the related winnings can be cashed out. For instance, a ৳1,000 bonus with 20x wagering means placing ৳20,000 in total bets to unlock those funds. We keep terms clear and transparent so you always know what to expect.",
        icon: "💳",
      },
      {
        q: "How do I know the games at HHBD are fair?",
        a: (
          `<>
            HHBD stands for fair play. All titles — especially{" "}
            <Link to="/slots" className="zHHBD-faq__link">
              slots
            </Link>{" "}
            — are powered by a certified RNG, ensuring outcomes are random and unbiased. Licensed casinos don’t rig games; it risks both license and reputation. We partner only with audited, leading providers to maintain integrity.
          </>`
        ),
        icon: "🎁",
      },
      {
        q: "What types of games can I play?",
        a: (
          `<>
            Our library spans countless{" "}
            <Link to="/games" className="zHHBD-faq__link">
              games
            </Link>{" "}
            for every taste. Enjoy hundreds of themed{" "}
            <Link to="/slots" className="zHHBD-faq__link">
              slots
            </Link>
            , step into the live casino for Blackjack and Roulette with real hosts, or choose classic table options like Poker and Baccarat when you want strategy forward.
          </>`
        ),
        icon: "🕹️",
      },
      {
        q: "Do I need to download an app to play?",
        a: "No installation is required. The HHBD site is fully optimized for mobile browsers, offering instant access on the go. Prefer a dedicated experience? We also provide a secure Android app for players who want it.",
        icon: "🔐",
      },
      {
        q: "Is my personal information kept private?",
        a: "Yes. We follow a strict privacy policy, using your details solely for verification and account management. We don’t sell data to third parties, and our security stack is designed to keep your information protected at all times.",
        icon: "📱",
      },
    ];




      const jsonLd = [
        // 1) WebSite (+SearchAction)
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": siteName,
          "url": origin,
          "inLanguage": isBN ? "bn" : "en",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${origin}/search?q={query}`,
            "query-input": "required name=query"
          }
        },

        // 2) WebPage (home)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": isBN ? "bn" : "en",
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": siteName, "url": origin }
        },

        // 3) Organization (➕ description)
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": siteName,
  "url": origin,
  "description": pageDescCaps,
  "logo": {a1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

}
,

        // 4) BreadcrumbList (для homepage это минимально)
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": isBN ? "হোম" : "Home",
              "item": currentAbsUrl
            }
          ]
        },

        // 5) FAQPage (делает страницу эллигибл к FAQ rich results)
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(({ q, a }) => ({
            "@type": "Question",
            "name": q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": a
            }
          }))}
        ,

        // 6) MobileApplication (опционально, если у тебя есть приложение / страница загрузки)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": `${siteName} App`,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {/* --- ENGLISH VERSION --- */}
      {lang === "en" && (
 <>
    <section className="zHHBD-hero">
      <div className="zHHBD-hero__bg">
        <div className="zHHBD-hero__bg-layer zHHBD-hero__link--primary"></div>
        <div className="zHHBD-hero__bg-layer zHHBD-hero__bg-layer--glow"></div>
      </div>
      <div className="zHHBD-hero__shell">
        <div className="zHHBD-hero__inner">
          <div className="hero-body">
            <header className="zHHBD-hero__header">
              <h1 className="zHHBD-hero__title">
               HHBD – Play, Win & Cash Out Instantly in Bangladesh
              </h1>
              <p className="zHHBD-hero__tagline">
                Enter HHBD, Bangladesh’s destination for first-class entertainment — a powerful mix of online{" "}
                <Link to="/casino" className="zHHBD-hero__link zHHBD-hero__link--games">casino</Link> action and
                high-energy sports <Link to="/bet" className="zHHBD-hero__link zHHBD-hero__link--slots"> betting</Link>.
                Explore a deep library of thrilling{" "}
                <Link to="/games" className="zHHBD-hero__link zHHBD-hero__link--games">games</Link>, back your favorite clubs with sharp wagers,
                and enjoy rapid, protected withdrawals. Join HHBD today and convert pure passion into consistent,
                measurable results.
              </p>
              <div className="zHHBD-hero__ctas">
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  className="zHHBD-hero__btn HHBD-hero__btn--filled"
                  title="Join HHBD Now"
                >
                  Join HHBD Now
                </a>
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  className="zHHBD-hero__btn HHBD-hero__btn--outline"
                  title="Download APK"
                >
                  Download APK
                </a>
              </div>
            </header>
            <figure className="zHHBD-hero__figure">
              <span className="zHHBD-hero__frame">
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  title="HHBD Casino – Discover premium online gaming and endless winning opportunities"
                >
                  <img
                    src={a1}
                    alt="A golden HHBD crest crowned above card suits — a refined symbol of trust, prestige, and serious online play."
                    title="HHBD Casino – Discover premium online gaming and endless winning opportunities"
                    className="zHHBD-hero__img"
                    fetchPriority="high"
                    decoding="async"
                    loading="eager"
                    width="1280" height="720"
                    sizes="(max-width: 768px) 100vw, 1280px"
                  />
                </a>
              </span>
            </figure>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-elevate">
      <div className="zHHBD-elevate__bg">
        <div className="zHHBD-elevate__bg-glow"></div>
        <div className="zHHBD-elevate__bg-grid"></div>
      </div>
      <div className="zHHBD-elevate__wrap">
        <header className="zHHBD-elevate__header">
          <h2 className="zHHBD-elevate__title">
            Kick Off Your HHBD Journey in Minutes
          </h2>
        </header>
        <div className="zHHBD-elevate__grid">
          <figure className="zHHBD-elevate__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Casino – Step into a world of colorful online gaming and wins"
            >
              <img
                src={a2}
                alt="A sleek player bathed in neon light, with cards and chips in motion — the vivid spirit of HHBD online play."
                title="HHBD Casino – Step into a world of colorful online gaming and wins"
                className="zHHBD-elevate__img"
              />
            </a>
          </figure>
          <div className="zHHBD-elevate__features">
            <p className="zHHBD-elevate__intro">
              Getting started on HHBD is quick and effortless — most newcomers are set up in under two minutes.
              Our sign-up is intentionally streamlined, asking for only the essentials to secure your account.
              Tap “Sign Up” on the homepage, fill in your email and password, and you’re almost ready.
              No long forms or confusing steps — just a direct path from registration to your favorite{" "}
              <Link to="/games" className="zHHBD-elevate__link HHBD-elevate__link--games">games</Link> at speed.
              We respect your time, aiming for a smooth, confident first impression that removes friction and
              puts you straight into premium online{" "}
              <Link to="/casino" className="zHHBD-elevate__link HHBD-elevate__link--casino">gaming</Link>.
            </p>
            <p className="zHHBD-elevate__text">
              After creating your profile, top it up with trusted local rails.
              HHBD supports Bangladesh favorites like bKash, Nagad, and Rocket, plus cards, bank transfer, and leading e-wallets.
              Open the cashier, pick your method, enter an amount, and confirm — deposits arrive instantly so you can play now.
              Every payment is wrapped in modern security with rigorous protocols for peace of mind.
              Once you’re funded, don’t forget to claim your generous{" "}
              <Link to="/bonuses" className="zHHBD-elevate__link HHBD-elevate__link--casino">welcome bonus</Link>
              — it powers up your starting balance and maximizes your first sessions.
            </p>
            <p className="zHHBD-elevate__text">
              With funds ready, explore the full HHBD universe.
              Browse 1,000+{" "}
              <Link to="/games" className="zHHBD-elevate__link HHBD-elevate__link--games">casino games</Link>, including fresh video{" "}
              <Link to="/slots" className="zHHBD-elevate__link HHBD-elevate__link--slots">slots</Link> packed with free spins, features, and jackpots.
              For real-time immersion, step into our{" "}
              <Link to="/casino" className="zHHBD-elevate__link HHBD-elevate__link--casino">live casino</Link> with professional dealers.
              If{" "}
              <Link to="/bet" className="zHHBD-elevate__link HHBD-elevate__link--games">sports</Link> is your arena, open the sportsbook for sharp odds across thousands of events.
              Use smart filters to pinpoint specific{" "}
              <Link to="/games" className="zHHBD-elevate__link HHBD-elevate__link--games">games</Link> and fixtures, and tailor your dashboard around favorites.
              The HHBD interface makes discovery fast, rewarding, and a joy to navigate.
            </p>
            <p className="zHHBD-elevate__text">
              Keep the momentum rolling with constant value.
              We refresh promotions, loyalty rewards, and seasonal specials that add extra spark to every session.
              Watch for new{" "}
              <Link to="/bonuses" className="zHHBD-elevate__link HHBD-elevate__link--casino">bonuses</Link>, free spins, cashback, and limited-time events — all tuned to amplify your play.
              Earn points as you go and exchange them for perks and tangible rewards.
              Visit the promos page or subscribe to our newsletter to stay ahead.
              At HHBD, your time matters — we elevate your experience end-to-end so you can enjoy a higher tier of online{" "}
              <Link to="/casino" className="zHHBD-elevate__link HHBD-elevate__link--casino">gaming</Link> excitement.
            </p>
            <div className="zHHBD-elevate__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-elevate__btn"
                title="Join HHBD Now"
              >
                Join HHBD Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-journey">
      <div className="zHHBD-journey__bg">
        <div className="zHHBD-journey__wave zHHBD-journey__wave--one"></div>
        <div className="zHHBD-journey__wave zHHBD-journey__wave--two"></div>
        <canvas className="zHHBD-journey__spark" id="journeySpark"></canvas>
      </div>
      <div className="zHHBD-journey__wrap">
        <header className="zHHBD-journey__header">
          <h2 className="zHHBD-journey__title">
            Signature HHBD Features You’ll Love
          </h2>
        </header>
        <div className="zHHBD-journey__cards">
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">Fast Bangladeshi Withdrawals</h3>
            <p className="zHHBD-journey__card-text">
              Cash out quickly using trusted local methods — smooth, dependable, and built for Bangladesh.
              Access your winnings without delay and stay in command of your bankroll.
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">Live Cricket Markets</h3>
            <p className="zHHBD-journey__card-text">
              Bet ball-by-ball with real-time, dynamic odds during cricket clashes.
              Feel every boundary and wicket in the moment and stake at just the right time.
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">Big Welcome Offers</h3>
            <p className="zHHBD-journey__card-text">
              Kick off with a sizeable newcomer package. Our{" "}
              <Link to="/bonuses" className="zHHBD-journey__link">bonuses</Link> add extra fuel
              so you can dive into more{" "}
              <Link to="/games" className="zHHBD-journey__link">games</Link> from day one.
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">Immersive Live Casino</h3>
            <p className="zHHBD-journey__card-text">
              Step inside our{" "}
              <Link to="/casino" className="zHHBD-journey__link">live casino</Link> for studio-real authenticity.
              Play roulette, blackjack, baccarat, and more with pro dealers and crisp HD streams.
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">Optimized for Mobile</h3>
            <p className="zHHBD-journey__card-text">
              Enjoy fluid, responsive play on any smartphone.
              HHBD goes wherever you do — quick loads, thoughtful UI, and frictionless experiences on the move.
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">24/7 Bangla Support</h3>
            <p className="zHHBD-journey__card-text">
              Friendly help whenever you need it. Reach us via live chat or email, in Bangla or English,
              any hour of the day.
            </p>
          </article>
        </div>
        <div className="zHHBD-journey__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-journey__btn"
            title="Join HHBD Now"
          >
            Join HHBD Now
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-gamesec">
      <div className="zHHBD-gamesec__bg">
        <div className="zHHBD-gamesec__glow HHBD-gamesec__glow--pink"></div>
        <div className="zHHBD-gamesec__glow HHBD-gamesec__glow--blue"></div>
        <ul className="zHHBD-gamesec__floaters">
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--slot">🎰</li>
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--cards">🃏</li>
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--rocket">🚀</li>
        </ul>
      </div>
      <div className="zHHBD-gamesec__wrap">
        <header className="zHHBD-gamesec__header">
          <h2 className="zHHBD-gamesec__title" title="Explore a Universe of Games at HHBD">
            Explore a Universe of Games at HHBD
          </h2>
        <p className="zHHBD-gamesec__intro">
            Enter a world of uninterrupted entertainment — HHBD’s library is handpicked for every taste and style.
            We partner with top studios to deliver today’s most popular and innovative titles online.
            Whether you crave rapid-fire{" "}
            <Link to="/slots" className="zHHBD-gamesec__link">slots</Link>, strategic table{" "}
            <Link to="/games" className="zHHBD-gamesec__link">games</Link>, or the rush of live{" "}
            <Link to="/bet" className="zHHBD-gamesec__link">sports betting</Link>, HHBD keeps the variety flowing with a growing portfolio.
            Our platform makes it simple to find and enjoy the{" "}
            <Link to="/games" className="zHHBD-gamesec__link">games</Link> you love — clean navigation, fast loading, and a seamless flow.
            Discover a new favorite today and see why HHBD is a leading pick for players across Bangladesh.
          </p>
        </header>
        <div className="zHHBD-gamesec__cards">
          <div className="games-cards-body">
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">A Huge Galaxy of Online Slots</h3>
              <p className="zHHBD-gamesec__card-text">
                Spin hundreds of online{" "}
                <Link to="/slots" className="zHHBD-gamesec__link">slots</Link> across every mood and theme.
                From classic fruit machines to modern video{" "}
                <Link to="/slots" className="zHHBD-gamesec__link">slots</Link> stacked with features and bonus rounds,
                the excitement never slows at HHBD.
              </p>
            </article>
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">Timeless Table Classics</h3>
              <p className="zHHBD-gamesec__card-text">
                Sharpen your skill set with Blackjack, Roulette, Baccarat, and more.
                Enjoy crisp presentation, smooth mechanics, and a range of variants that keep every session fresh.
              </p>
            </article>
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">Real Live Dealer Experiences</h3>
              <p className="zHHBD-gamesec__card-text">
                Bring the real-world{" "}
                <Link to="/casino" className="zHHBD-gamesec__link">casino</Link> to your screen.
                Our live dealer{" "}
                <Link to="/games" className="zHHBD-gamesec__link">games</Link> stream in HD with professional croupiers,
                delivering an interactive, immersive atmosphere.
              </p>
            </article>
          </div>
          <img
            src={a3}
            className="zHHBD-gamesec__img-extra"
            alt="An elegant player under neon ambiance, cards and chips in motion — the colorful energy of HHBD."
            title="HHBD Casino – Step into a world of colorful online gaming and wins"
          />
        </div>
        <div className="zHHBD-gamesec__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-gamesec__btn"
            title="Join HHBD Now"
          >
            Join HHBD Now
          </a>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Casino – Step into a world of colorful online gaming and wins"
        >
        </a>
      </div>
    </section>

    <section className="zHHBD-cardsec">
      <div className="zHHBD-cardsec__bg">
        <i className="fa-solid fa-lock HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-shield-halved HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-user-shield HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-badge-check HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-gavel HHBD-cardsec__icon"></i>
      </div>

      <div className="zHHBD-cardsec__container">
        <header className="zHHBD-cardsec__header">
          <h2 className="zHHBD-cardsec__title">
            Supercharge Your Bankroll with HHBD Promos
          </h2>

          <p className="zHHBD-cardsec__intro">
            HHBD gives you more ways to play — and more reasons to celebrate. Our promotions deliver extra value
            for new sign-ups and loyal members alike. We constantly refresh offers to mark special dates,
            major sporting events, and fresh launches so the buzz never fades.
            From deposit{" "}
            <Link to="/bonuses" className="zHHBD-cardsec__link" data-discover="true">bonuses</Link> that lift your balance
            to free spins that let you test the hottest{" "}
            <Link to="/slots" className="zHHBD-cardsec__link" data-discover="true">slots</Link> without spending your own funds,
            every deal layers more fun onto your{" "}
            <Link to="/games" className="zHHBD-cardsec__link" data-discover="true">gaming</Link>.
            We also feature cashback to cushion variance and maintain momentum.
            Browse the current lineup below and capture these advantages to push your potential further.
          </p>
        </header>

        <p className="zHHBD-cardsec__intro">
          Welcome Bonus for New Players — Launch your HHBD story with a serious head start.
          Our newcomer package typically matches your first deposit by a meaningful percentage,
          giving you extra room to explore our full selection of{" "}
          <Link to="/games" className="zHHBD-cardsec__link" data-discover="true">games</Link>.
          It’s an ideal way to try brand-new{" "}
          <Link to="/slots" className="zHHBD-cardsec__link" data-discover="true">slots</Link>, refine strategies at table games,
          or size up wagers on your favorite{" "}
          <Link to="/bet" className="zHHBD-cardsec__link" data-discover="true">sports</Link>.
          Consider it our thank-you for choosing HHBD in Bangladesh.
          Review the clear terms to maximize returns, claim the offer, and begin with a bigger bankroll.
        </p>

        <p className="zHHBD-cardsec__intro">
          Weekly Cashback — Each week brings fresh chances, and our cashback provides a soft landing.
          Receive a portion of your net losses back on selected{" "}
          <Link to="/games" className="zHHBD-cardsec__link" data-discover="true">games</Link> or sitewide, often credited automatically.
          It’s a straightforward way to soften swings and keep your sessions moving.
          Check your account or the{" "}
          <Link to="/bonuses" className="zHHBD-cardsec__link" data-discover="true">promotions</Link> page for eligibility,
          and play with added confidence knowing the cushion is in place.
        </p>

        <p className="zHHBD-cardsec__intro">
          Exclusive Free Spins — Love online{" "}
          <Link to="/slots" className="zHHBD-cardsec__link" data-discover="true">slots</Link>? Watch for our free spin drops.
          We regularly showcase top-performing video{" "}
          <Link to="/slots" className="zHHBD-cardsec__link" data-discover="true">slots</Link> with spin packs that cost nothing
          yet can still produce real wins. You’ll find them inside welcome bundles and as stand-alone promos for existing members.
          They’re the perfect way to sample new{" "}
          <Link to="/games" className="zHHBD-cardsec__link" data-discover="true">games</Link> and bonus features without spending a Taka.
          Keep an eye on the{" "}
          <Link to="/bonuses" className="zHHBD-cardsec__link" data-discover="true">promotions</Link> page, claim your spins, and chase headline payouts.
        </p>

        <p className="zHHBD-cardsec__safety">
          At HHBD, we’re committed to adding value to every minute you play — making your time here more rewarding, session after session.
        </p>

        <div className="zHHBD-cardsec__bottom">
          <figure className="zHHBD-cardsec__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Casino – Claim your rewards and win real prizes in Bangladesh"
            >
              <img
                className="zHHBD-cardsec__img"
                src={a4}
                alt="A confident player in bold red with gold coins in motion — a snapshot of big wins at HHBD."
                title="HHBD Casino – Claim your rewards and win real prizes in Bangladesh"
              />
            </a>
          </figure>

          <div className="zHHBD-cardsec__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-cardsec__btn"
              title="Join HHBD Now"
            >
              Join HHBD Now
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-standard">
      <div className="zHHBD-standard__container">
        <div className="zHHBD-standard__grid">
          <div className="zHHBD-standard__content">
            <h2 className="zHHBD-standard__title">
              Safe, Licensed &amp; Fair — Built for Bangladesh
            </h2>
            <p className="zHHBD-standard__text">
              At HHBD, protection comes first. We operate under a respected international license
              that enforces strict fairness and transparency standards.
              Our{" "}
              <Link to="/games" className="zHHBD-standard__link">games</Link> undergo routine, independent audits
              to validate integrity and randomness — so you can play with absolute confidence.
            </p>
            <p className="zHHBD-standard__text">
              Your data stays secure. All traffic is safeguarded by 128-bit SSL — the same grade trusted across leading industries.
              With layered defenses and smart firewalls, your identity and account information remain private.
            </p>
            <p className="zHHBD-standard__text">
              Payments are treated with care. HHBD integrates vetted gateways for deposits and withdrawals —
              from bKash and Nagad to crypto options — protected by end-to-end encryption.
              Our anti-fraud team works around the clock to identify and stop suspicious patterns,
              keeping your funds safe and payouts smooth.
            </p>
            <p className="zHHBD-standard__text">
              We champion healthy play. Entertainment should remain balanced and fun, so we provide deposit limits,
              session reminders, and self-exclusion. You’ll also find links to professional resources.
              Safeguarding our community is central to our mission.
            </p>
            <div className="zHHBD-standard__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-standard__btn"
                title="Start your secure HHBD journey right away"
              >
                Play Safely on HHBD Now
              </a>
            </div>
          </div>
          <figure className="zHHBD-standard__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD - Secure and licensed online gaming in Bangladesh"
            >
              <img
                src={a5}
                alt="A glowing padlock on a sleek display beside a confident player — a visual cue for HHBD’s secure, licensed play."
                title="HHBD - Secure and licensed online gaming in Bangladesh"
                className="zHHBD-standard__img"
              />
            </a>
          </figure>
        </div>
      </div>
    </section>

    <section className="zHHBD-faq" ref={faqRef}>
      <div className="zHHBD-faq__bg">
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
      </div>
      <div className="zHHBD-faq__container">
        <header className="zHHBD-faq__header">
          <h2 className="zHHBD-faq__title">
            HHBD: Frequently Asked Questions (FAQ) for Bangladesh
          </h2>
        </header>
        <div className="zHHBD-faq__accordion">
          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">💲</i>
              Is it safe to play at HHBD in Bangladesh?
            </button>
            <div className="zHHBD-faq__a">
              Absolutely — your safety is our top priority. HHBD uses advanced SSL encryption for personal data and payments.
              We follow rigorous international standards to maintain a secure, fair environment for every player.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">⏰</i>
              How can I deposit funds using bKash or Nagad?
            </button>
            <div className="zHHBD-faq__a">
              It’s quick and easy. Log in, head to “Deposit,” and select bKash or Nagad.
              You’ll receive our official wallet and a unique reference ID.
              Complete the transfer in your app — the funds usually appear in your HHBD balance almost instantly.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🔒</i>
              How long does it take to withdraw my winnings?
            </button>
            <div className="zHHBD-faq__a">
              We move fast. Payouts to bKash and Nagad typically complete within 15–30 minutes.
              Our payments team prioritizes speed so you can access your winnings without delay.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">📱</i>
              What kind of bonuses can I get as a new player?
            </button>
            <div className="zHHBD-faq__a">
              New Bangladeshi players often receive a generous welcome — typically a matched deposit plus free spins on popular{" "}
              <Link to="/slots" className="zHHBD-journey__link">slot</Link>{" "}
              <Link to="/games" className="zHHBD-journey__link">games</Link>.
              Keep an eye on our <Link to="/bonuses" className="zHHBD-journey__link">'Promotions'</Link> page for current offers and simple terms.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🎲</i>
              Can I play HHBD games on my mobile phone?
            </button>
            <div className="zHHBD-faq__a">
              Definitely. HHBD is fully optimized for smartphones.
              Play our entire lineup of{" "}
              <Link to="/slots" className="zHHBD-journey__link">slots</Link>, table{" "}
              <Link to="/games" className="zHHBD-journey__link">games</Link>, and{" "}
              <Link to="/casino" className="zHHBD-journey__link">live casino</Link> titles from your mobile browser — no app required.
              It’s fast, fluid, and built for gaming anywhere.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">💬</i>
              Are the games at HHBD fair?
            </button>
            <div className="zHHBD-faq__a">
              Fairness is foundational at HHBD. All{" "}
              <Link to="/games" className="zHHBD-journey__link">games</Link> come from reputable providers
              and use certified RNG technology, ensuring outcomes are random, unbiased, and tamper-proof.
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🎯</i>
              What should I do if I need help or support?
            </button>
            <div className="zHHBD-faq__a">
              Our team is available 24/7. Open Live Chat for immediate assistance, or send us an email.
              We’re happy to help in English or Bangla — whichever you prefer.
            </div>
          </div>
        </div>
        <div className="zHHBD-faq__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-faq__btn"
            title="Join HHBD Now"
          >
            Join HHBD Now
          </a>
        </div>
      </div>
    </section>
  </>




      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
 <>
    <section className="zHHBD-hero">
      <div className="zHHBD-hero__bg">
        <div className="zHHBD-hero__bg-layer zHHBD-hero__link--primary"></div>
        <div className="zHHBD-hero__bg-layer zHHBD-hero__bg-layer--glow"></div>
      </div>
      <div className="zHHBD-hero__shell">
        <div className="zHHBD-hero__inner">
          <div className="hero-body">
            <header className="zHHBD-hero__header">
              <h1 className="zHHBD-hero__title">
               HHBD – বাংলাদেশে তাৎক্ষণিকভাবে খেলুন, জিতুন এবং ক্যাশ আউট করুন
              </h1>
              <p className="zHHBD-hero__tagline">
                HHBD-এ স্বাগতম, বাংলাদেশের ফার্স্ট-ক্লাস এন্টারটেইনমেন্টের গন্তব্য — অনলাইন{" "}
                <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> অ্যাকশন আর
                হাই-এনার্জি স্পোর্টস{" "}
                <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">বেটিং</Link>—এর শক্তিশালী মিশ্রণ।
                রোমাঞ্চকর{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>–এর গভীর লাইব্রেরি ঘুরে দেখুন,
                পছন্দের ক্লাবের পক্ষে ধারালো ওয়েজার রাখুন, আর উপভোগ করুন দ্রুত ও সুরক্ষিত উত্তোলন।
                আজই HHBD–এ যোগ দিন এবং নিখাদ প্যাশনকে ধারাবাহিক, পরিমাপযোগ্য সাফল্যে রূপান্তর করুন।
              </p>
              <div className="zHHBD-hero__ctas">
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  className="zHHBD-hero__btn HHBD-hero__btn--filled"
                  title="এখনই HHBD–এ যোগ দিন"
                >
                  এখনই HHBD–এ যোগ দিন
                </a>
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  className="zHHBD-hero__btn HHBD-hero__btn--outline"
                  title="APK ডাউনলোড করুন"
                >
                  APK ডাউনলোড করুন
                </a>
              </div>
            </header>
            <figure className="zHHBD-hero__figure">
              <span className="zHHBD-hero__frame">
                <a
                  href="https://haruvest.com/W7DZsfpK"
                  title="HHBD Casino – প্রিমিয়াম অনলাইন গেমিং ও সীমাহীন জয়ের সুযোগ আবিষ্কার করুন"
                >
                  <img
                    src={a1}
                    alt="সোনালি HHBD ক্রেস্ট—কার্ড স্যুটের উপরে মুকুট—বিশ্বাস, মর্যাদা ও সিরিয়াস অনলাইন প্লের পরিশীলিত প্রতীক।"
                    title="HHBD Casino – প্রিমিয়াম অনলাইন গেমিং ও সীমাহীন জয়ের সুযোগ আবিষ্কার করুন"
                    className="zHHBD-hero__img"
                    fetchPriority="high"
                    decoding="async"
                    loading="eager"
                    width="1280" height="720"
                    sizes="(max-width: 768px) 100vw, 1280px"
                  />
                </a>
              </span>
            </figure>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-elevate">
      <div className="zHHBD-elevate__bg">
        <div className="zHHBD-elevate__bg-glow"></div>
        <div className="zHHBD-elevate__bg-grid"></div>
      </div>
      <div className="zHHBD-elevate__wrap">
        <header className="zHHBD-elevate__header">
          <h2 className="zHHBD-elevate__title">
            কয়েক মিনিটেই শুরু করুন আপনার HHBD যাত্রা
          </h2>
        </header>
        <div className="zHHBD-elevate__grid">
          <figure className="zHHBD-elevate__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Casino – রঙিন অনলাইন গেমিং ও জয়ের জগতে পা রাখুন"
            >
              <img
                src={a2}
                alt="নিয়ন আলোয় স্নাত এক স্মার্ট প্লেয়ার—কার্ড ও চিপস ঘূর্ণায়মান—HHBD অনলাইন প্লের জীবন্ত স্পিরিট।"
                title="HHBD Casino – রঙিন অনলাইন গেমিং ও জয়ের জগতে পা রাখুন"
                className="zHHBD-elevate__img"
              />
            </a>
          </figure>
          <div className="zHHBD-elevate__features">
            <p className="zHHBD-elevate__intro">
              HHBD–এ শুরু করা দ্রুত ও ঝামেলাহীন — বেশিরভাগ নবাগত দুই মিনিটেরও কম সময়ে সেটআপ সম্পন্ন করেন।
              আমাদের সাইন-আপ সচেতনভাবে সরল রাখা হয়েছে; কেবল আপনার অ্যাকাউন্ট সুরক্ষার জন্য প্রয়োজনীয় তথ্যই চাওয়া হয়।
              হোমপেজে “Sign Up”–এ ট্যাপ করুন, ইমেইল ও পাসওয়ার্ড দিন, আর প্রায় প্রস্তুত।
              কোনো বড় ফর্ম বা বিভ্রান্তিকর ধাপ নেই — রেজিস্ট্রেশন থেকে প্রিয়{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>–এ যাওয়ার সরাসরি, দ্রুত পথ।
              আমরা আপনার সময়কে মূল্য দিই; প্রথম অভিজ্ঞতাটিকে স্মুথ ও আত্মবিশ্বাসী করে তোলাই লক্ষ্য,
              যাতে আপনি সরাসরি প্রিমিয়াম অনলাইন{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">গেমিং</Link>–এ প্রবেশ করতে পারেন।
            </p>
            <p className="zHHBD-elevate__text">
              প্রোফাইল তৈরি হয়ে গেলে, ভরুন বিশ্বস্ত লোকাল চ্যানেলে।
              HHBD সাপোর্ট করে bKash, Nagad, Rocket—বাংলাদেশের পছন্দের অপশন, সাথে কার্ড, ব্যাংক ট্রান্সফার ও শীর্ষ ই-ওয়ালেট।
              ক্যাশিয়ারে যান, পদ্ধতি বাছুন, অ্যামাউন্ট দিন ও কনফার্ম করুন — ডিপোজিট প্রায় ইনস্ট্যান্ট, তাই এখনই খেলা শুরু করতে পারবেন।
              প্রতিটি পেমেন্ট আধুনিক সিকিউরিটিতে আবৃত; কঠোর প্রোটোকল আপনাকে মানসিক স্বস্তি দেয়।
              ফান্ডেড হলে উদার{" "}
              <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link">ওয়েলকাম বোনাস</Link> নিতে ভুলবেন না —
              এটি আপনার স্টার্টিং ব্যালেন্স ‘পাওয়ার আপ’ করে প্রথম কয়েকটি সেশনকেই সর্বোচ্চ করে তোলে।
            </p>
            <p className="zHHBD-elevate__text">
              ফান্ড রেডি হলে, HHBD–এর পুরো ইউনিভার্স এক্সপ্লোর করুন।
              ১,০০০+{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">ক্যাসিনো গেমস</Link> ব্রাউজ করুন; নতুন ভিডিও{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>—এ ফ্রি স্পিন, ফিচারস ও জ্যাকপট ভরপুর।
              লাইভ ইমারসনের জন্য আমাদের{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">লাইভ ক্যাসিনো</Link>–তে ঢুকে পড়ুন প্রফেশনাল ডিলারদের সাথে।
              আর যদি{" "}
              <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস</Link> আপনার এরিনা হয়, তবে হাজারো ইভেন্টে ধারালো অডস পেতে স্পোর্টসবুকে যান।
              স্মার্ট ফিল্টার দিয়ে নির্দিষ্ট{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> ও ফিক্সচার খুঁজুন, ড্যাশবোর্ড সাজান ফেভারিট অনুযায়ী।
              HHBD ইন্টারফেসে ডিসকভারি দ্রুত, রিওয়ার্ডিং এবং নেভিগেট করতেও আনন্দদায়ক।
            </p>
            <p className="zHHBD-elevate__text">
              ধারাবাহিক ভ্যালু দিয়ে গতি বজায় রাখুন।
              আমরা নিয়মিত প্রোমোশন, লয়্যালটি রিওয়ার্ড এবং সিজনাল স্পেশালস রিফ্রেশ করি—প্রতিটি সেশনে বাড়তি উজ্জ্বলতা যোগ করতে।
              নতুন{" "}
              <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link">বোনাস</Link>, ফ্রি স্পিন, ক্যাশব্যাক ও সীমিত সময়ের ইভেন্টগুলোর খোঁজ রাখুন—সবই আপনার খেলা বাড়াতে টিউন করা।
              খেলতে খেলতে পয়েন্ট উপার্জন করুন এবং সুবিধা ও বাস্তব রিওয়ার্ডে এক্সচেঞ্জ করুন।
              প্রোমো পেজ ভিজিট করুন বা নিউজলেটারে সাবস্ক্রাইব করে আপডেটেড থাকুন।
              HHBD–এ আপনার সময়ই মূল্যবান—আমরা শুরু থেকে শেষ পর্যন্ত অভিজ্ঞতাকে উন্নত করি, যাতে আপনি অনলাইন{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">গেমিং</Link>–এর উচ্চতর স্তর উপভোগ করতে পারেন।
            </p>
            <div className="zHHBD-elevate__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-elevate__btn"
                title="এখনই HHBD–এ যোগ দিন"
              >
                এখনই HHBD–এ যোগ দিন
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-journey">
      <div className="zHHBD-journey__bg">
        <div className="zHHBD-journey__wave zHHBD-journey__wave--one"></div>
        <div className="zHHBD-journey__wave zHHBD-journey__wave--two"></div>
        <canvas className="zHHBD-journey__spark" id="journeySpark"></canvas>
      </div>
      <div className="zHHBD-journey__wrap">
        <header className="zHHBD-journey__header">
          <h2 className="zHHBD-journey__title">
            সিগনেচার HHBD ফিচারস—যেগুলো আপনি ভালোবাসবেন
          </h2>
        </header>
        <div className="zHHBD-journey__cards">
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">দ্রুত বাংলাদেশি উত্তোলন</h3>
            <p className="zHHBD-journey__card-text">
              বিশ্বস্ত লোকাল পদ্ধতিতে ত্বরিত ক্যাশআউট — স্মুথ, নির্ভরযোগ্য এবং বাংলাদেশের জন্য নির্মিত।
              বিলম্ব ছাড়াই জেতা অর্থ তুলুন এবং আপনার ব্যাংকরোলের নিয়ন্ত্রণ নিজের হাতে রাখুন।
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">লাইভ ক্রিকেট মার্কেট</h3>
            <p className="zHHBD-journey__card-text">
              ক্রিকেট দ্বৈরথে রিয়েল-টাইম, ডায়নামিক অডসে বল-বাই-বল বেট করুন।
              প্রতিটি বাউন্ডারি ও উইকেট মুহূর্তেই অনুভব করুন এবং সঠিক টাইমিংয়ে স্টেক করুন।
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">বড়সড় ওয়েলকাম অফার</h3>
            <p className="zHHBD-journey__card-text">
              আকর্ষণীয় নবাগত প্যাকেজ দিয়ে শুরু করুন। আমাদের{" "}
              <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link">বোনাস</Link> বাড়তি জ্বালানি যোগায়,
              যাতে প্রথম দিন থেকেই আরও বেশি{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> এক্সপ্লোর করতে পারেন।
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">ইমারসিভ লাইভ ক্যাসিনো</h3>
            <p className="zHHBD-journey__card-text">
              আমাদের{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">লাইভ ক্যাসিনো</Link>–তে স্টুডিওর মতো বাস্তব অভিজ্ঞতা।
              প্রফেশনাল ডিলার ও ক্রিস্প HD স্ট্রিমে রুলেট, ব্ল্যাকজ্যাক, ব্যাকারাট ইত্যাদি খেলুন।
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">মোবাইলের জন্য অপটিমাইজড</h3>
            <p className="zHHBD-journey__card-text">
              যেকোনো স্মার্টফোনে ফ্লুইড, রেসপনসিভ প্লে উপভোগ করুন।
              HHBD আপনার সাথে চলাফেরা করে — দ্রুত লোড, যত্নশীল UI, আর চলতে ফিরতে ঘর্ষণহীন অভিজ্ঞতা।
            </p>
          </article>
          <article className="zHHBD-journey__card">
            <h3 className="zHHBD-journey__card-title">২৪/৭ বাংলা সাপোর্ট</h3>
            <p className="zHHBD-journey__card-text">
              যখনই দরকার, থাকছে বন্ধুসুলভ সহায়তা। লাইভ চ্যাট অথবা ইমেইলে যোগাযোগ করুন — বাংলা বা ইংরেজি যেটিতে চান।
            </p>
          </article>
        </div>
        <div className="zHHBD-journey__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-journey__btn"
            title="এখনই HHBD–এ যোগ দিন"
          >
            এখনই HHBD–এ যোগ দিন
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-gamesec">
      <div className="zHHBD-gamesec__bg">
        <div className="zHHBD-gamesec__glow HHBD-gamesec__glow--pink"></div>
        <div className="zHHBD-gamesec__glow HHBD-gamesec__glow--blue"></div>
        <ul className="zHHBD-gamesec__floaters">
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--slot">🎰</li>
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--cards">🃏</li>
          <li className="zHHBD-gamesec__icon HHBD-gamesec__icon--rocket">🚀</li>
        </ul>
      </div>
      <div className="zHHBD-gamesec__wrap">
        <header className="zHHBD-gamesec__header">
          <h2 className="zHHBD-gamesec__title" title="HHBD–এ গেমসের এক মহাবিশ্ব এক্সপ্লোর করুন">
            HHBD–এ গেমসের এক মহাবিশ্ব এক্সপ্লোর করুন
          </h2>
          <p className="zHHBD-gamesec__intro">
            নিরবচ্ছিন্ন এন্টারটেইনমেন্টের দুনিয়ায় প্রবেশ করুন — HHBD–এর লাইব্রেরি প্রতিটি রুচি ও স্টাইলের জন্য হাতে–তোলা।
            শীর্ষ স্টুডিওর সাথে অংশীদারিত্বে আমরা আজকের সবচেয়ে জনপ্রিয় ও ইনোভেটিভ টাইটেলগুলো নিয়ে আসি।
            দ্রুত ছন্দের{" "}
            <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>, কৌশলী টেবিল{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> অথবা লাইভ{" "}
            <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস বেটিং</Link>–এর রোমাঞ্চ—HHBD ক্রমবর্ধমান পোর্টফোলিওতে বৈচিত্র্য ধরে রাখে।
            আমাদের প্ল্যাটফর্মে আপনার প্রিয়{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> খুঁজে পাওয়া ও উপভোগ করা সহজ —
            ক্লিন ন্যাভিগেশন, ফাস্ট লোডিং ও সিমলেস ফ্লো।
            আজই নতুন প্রিয় খুঁজে নিন এবং দেখুন কেন HHBD বাংলাদেশের প্লেয়ারদের শীর্ষ পছন্দ।
          </p>
        </header>
        <div className="zHHBD-gamesec__cards">
          <div className="games-cards-body">
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">অনলাইন স্লটসের এক বিশাল গ্যালাক্সি</h3>
              <p className="zHHBD-gamesec__card-text">
                শত শত অনলাইন{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link> ঘুরিয়ে দেখুন—সব মুড ও থিম জুড়ে।
                ক্ল্যাসিক ফ্রুট মেশিন থেকে শুরু করে আধুনিক ভিডিও{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>—ফিচারস ও বোনাস রাউন্ডে ঠাসা—
                HHBD–এ উত্তেজনা থামে না কখনো।
              </p>
            </article>
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">চিরন্তন টেবিল ক্ল্যাসিকস</h3>
              <p className="zHHBD-gamesec__card-text">
                ব্ল্যাকজ্যাক, রুলেট, ব্যাকারাট–এ দক্ষতা শাণিত করুন।
                ক্রিস্প প্রেজেন্টেশন, স্মুথ মেকানিক্স ও নানান ভ্যারিয়েন্ট প্রতি সেশনকে রাখে টাটকা।
              </p>
            </article>
            <article className="zHHBD-gamesec__card">
              <h3 className="zHHBD-gamesec__card-title">রিয়াল লাইভ ডিলার এক্সপেরিয়েন্স</h3>
              <p className="zHHBD-gamesec__card-text">
                বাস্তব{" "}
                <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> নিয়ে আসুন আপনার স্ক্রিনে।
                আমাদের লাইভ ডিলার{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> HD–তে স্ট্রিম হয় প্রফেশনাল ক্রুপিয়ারদের সাথে,
                তৈরি করে ইন্টারঅ্যাকটিভ, ইমারসিভ পরিবেশ।
              </p>
            </article>
          </div>
          <img
            src={a3}
            className="zHHBD-gamesec__img-extra"
            alt="নিয়ন আবহে এক এলিগ্যান্ট প্লেয়ার—কার্ড ও চিপস চলমান—HHBD–এর রঙিন এনার্জি।"
            title="HHBD Casino – রঙিন অনলাইন গেমিং ও জয়ের জগতে পা রাখুন"
          />
        </div>
        <div className="zHHBD-gamesec__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-gamesec__btn"
            title="এখনই HHBD–এ যোগ দিন"
          >
            এখনই HHBD–এ যোগ দিন
          </a>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Casino – রঙিন অনলাইন গেমিং ও জয়ের জগতে পা রাখুন"
        >
        </a>
      </div>
    </section>

    <section className="zHHBD-cardsec">
      <div className="zHHBD-cardsec__bg">
        <i className="fa-solid fa-lock HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-shield-halved HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-user-shield HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-badge-check HHBD-cardsec__icon"></i>
        <i className="fa-solid fa-gavel HHBD-cardsec__icon"></i>
      </div>

      <div className="zHHBD-cardsec__container">
        <header className="zHHBD-cardsec__header">
          <h2 className="zHHBD-cardsec__title">
            HHBD প্রোমো দিয়ে আপনার ব্যাংকরোল সুপারচার্জ করুন
          </h2>

          <p className="zHHBD-cardsec__intro">
            HHBD আপনাকে দেয় আরও বেশি খেলার উপায়—আর বেশি উদযাপনের কারণ। আমাদের প্রোমোশন নতুন সাইন–আপ ও লয়্যাল
            মেম্বার—সবার জন্যই বাড়তি ভ্যালু পৌঁছে দেয়। বিশেষ তারিখ, বড় ক্রীড়া ইভেন্ট ও নতুন লঞ্চ ঘিরে অফারগুলো
            আমরা নিয়ত রিফ্রেশ করি—উত্তেজনা যাতে কখনো ম্লান না হয়।
            ডিপোজিট{" "}
            <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link" data-discover="true">বোনাস</Link> যা আপনার ব্যালেন্স তুলতে সাহায্য করে,
            থেকে শুরু করে ফ্রি স্পিন—যা দিয়ে আপনি সবচেয়ে হট{" "}
            <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> ট্রাই করতে পারেন নিজের ফান্ড না খরচ করেই—
            প্রতিটি ডিল আপনার{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমিং</Link>–এ নতুন মজা যোগ করে।
            ক্যাশব্যাক অপশনও আছে—ভ্যারিয়েন্স নরম করে মোমেন্টাম বজায় রাখার জন্য।
            নিচের বর্তমান লাইনআপ দেখুন এবং এগুলো ক্যাপচার করে আপনার সম্ভাবনা আরও দূর এগিয়ে নিন।
          </p>
        </header>

        <p className="zHHBD-cardsec__intro">
          নতুন প্লেয়ারদের জন্য ওয়েলকাম বোনাস — HHBD গল্প শুরু করুন এক শক্তিশালী এগিয়ে–থাকা দিয়ে।
          নবাগত প্যাকেজ সাধারণত আপনার প্রথম ডিপোজিটকে উল্লেখযোগ্য হারে ম্যাচ করে,
          যাতে আমাদের পুরো{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> সিলেকশন আরও বিস্তৃতভাবে এক্সপ্লোর করতে পারেন।
          এটি ব্র্যান্ড–নিউ{" "}
          <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> চেষ্টা করা, টেবিল গেমে কৌশল শাণিত করা
          অথবা প্রিয়{" "}
          <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link" data-discover="true">স্পোর্টস</Link>–এ বেট সাইজ আপ করার আদর্শ উপায়।
          বাংলাদেশে HHBD বেছে নেওয়ার জন্য এটি আমাদের ধন্যবাদ।
          পরিষ্কার শর্ত পড়ে রিটার্ন সর্বোচ্চ করুন, অফার ক্লেইম করুন ও বড় ব্যাংকরোলে যাত্রা শুরু করুন।
        </p>

        <p className="zHHBD-cardsec__intro">
          সাপ্তাহিক ক্যাশব্যাক — প্রতি সপ্তাহ নতুন সুযোগ নিয়ে আসে, আর আমাদের ক্যাশব্যাক দেয় সফট ল্যান্ডিং।
          নির্বাচিত{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link>–এ বা সাইট–জুড়ে আপনার নিট লসের একটি অংশ ফেরত পান,
          অনেক সময় স্বয়ংক্রিয়ভাবে ক্রেডিট হয়।
          সুইং নরম করার এবং সেশনের গতি বজায় রাখার সহজ উপায় এটি।
          আপনার অ্যাকাউন্ট বা{" "}
          <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link" data-discover="true">প্রোমোশন</Link> পেজে যোগ্যতা দেখে নিন,
          আর বাড়তি আত্মবিশ্বাস নিয়ে খেলুন—জানেন তো, কুশন আছে।
        </p>

        <p className="zHHBD-cardsec__intro">
          এক্সক্লুসিভ ফ্রি স্পিন — অনলাইন{" "}
          <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> ভালোবাসেন?
          আমাদের ফ্রি স্পিন ড্রপগুলোর জন্য নজর রাখুন।
          আমরা নিয়মিত শীর্ষ–পারফর্মিং ভিডিও{" "}
          <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–কে স্পিন প্যাকসহ হাইলাইট করি—
          যেগুলোতে খরচ নেই, তবু বাস্তব জয় এনে দিতে পারে।
          এগুলো পাবেন ওয়েলকাম বান্ডল–এ ও বিদ্যমান সদস্যদের স্ট্যান্ড–অ্যালোন প্রোমো হিসেবে।
          নতুন{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> ও বোনাস ফিচার স্যাম্পল করার পারফেক্ট উপায়—
          এক টাকাও খরচ না করে।
          নজর রাখুন{" "}
          <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link" data-discover="true">প্রোমোশন</Link> পেজে, স্পিন ক্লেইম করুন, আর হেডলাইন পেআউটের পিছু নিন।
        </p>

        <p className="zHHBD-cardsec__safety">
          HHBD–এ আমরা আপনার খেলার প্রতিটি মিনিটে ভ্যালু যোগ করতে প্রতিশ্রুতিবদ্ধ — প্রতিটি সেশনকে আরও রিওয়ার্ডিং করে তুলতে।
        </p>

        <div className="zHHBD-cardsec__bottom">
          <figure className="zHHBD-cardsec__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Casino – বাংলাদেশে আপনার রিওয়ার্ড ক্লেইম করুন এবং বাস্তব পুরস্কার জিতুন"
            >
              <img
                className="zHHBD-cardsec__img"
                src={a4}
                alt="গভীর লাল পোশাকে আত্মবিশ্বাসী প্লেয়ার—সোনালি কয়েন উড়ছে—HHBD–এ বড় জয়ের স্ন্যাপশট।"
                title="HHBD Casino – বাংলাদেশে আপনার রিওয়ার্ড ক্লেইম করুন এবং বাস্তব পুরস্কার জিতুন"
              />
            </a>
          </figure>

          <div className="zHHBD-cardsec__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-cardsec__btn"
              title="এখনই HHBD–এ যোগ দিন"
            >
              এখনই HHBD–এ যোগ দিন
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-standard">
      <div className="zHHBD-standard__container">
        <div className="zHHBD-standard__grid">
          <div className="zHHBD-standard__content">
            <h2 className="zHHBD-standard__title">
              সেফ, লাইসেন্সধারী ও ফেয়ার — বাংলাদেশকে মাথায় রেখে নির্মিত
            </h2>
            <p className="zHHBD-standard__text">
              HHBD–এ সুরক্ষা সবার আগে। আমরা সম্মানিত আন্তর্জাতিক লাইসেন্সের আওতায় পরিচালিত,
              যেখানে কঠোর ফেয়ারনেস ও ট্রান্সপারেন্সি স্ট্যান্ডার্ড কার্যকর।
              আমাদের{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> নিয়মিত, স্বাধীন অডিটে যায়
              যাতে ইন্টিগ্রিটি ও র‍্যান্ডমনেস যাচাই হয় — ফলে আপনি নির্ভেজাল আত্মবিশ্বাস নিয়ে খেলতে পারেন।
            </p>
            <p className="zHHBD-standard__text">
              আপনার ডাটা সুরক্ষিত থাকে। সাইটের সব ট্র্যাফিক ১২৮-বিট SSL–এ সুরক্ষিত — যা শীর্ষ শিল্পক্ষেত্রেও ভরসাযোগ্য।
              লেয়ার্ড ডিফেন্স ও স্মার্ট ফায়ারওয়াল আপনার পরিচয় ও অ্যাকাউন্ট তথ্যকে রাখে গোপনীয়।
            </p>
            <p className="zHHBD-standard__text">
              পেমেন্টকে আমরা বিশেষ যত্নে দেখি। HHBD ডিপোজিট ও উইথড্রয়ালের জন্য যাচাইকৃত গেটওয়ে ইন্টিগ্রেট করে —
              bKash, Nagad থেকে শুরু করে ক্রিপ্টো অপশন পর্যন্ত — এন্ড-টু-এন্ড এনক্রিপশনে সুরক্ষিত।
              আমাদের অ্যান্টি–ফ্রড টিম ২৪/৭ কাজ করে সন্দেহজনক প্যাটার্ন ধরতে ও থামাতে,
              যাতে আপনার ফান্ড সেফ থাকে ও পেআউট স্মুথ হয়।
            </p>
            <p className="zHHBD-standard__text">
              আমরা হেলদি প্লে সমর্থন করি। এন্টারটেইনমেন্ট ভারসাম্যপূর্ণ ও আনন্দদায়ক থাকা উচিত, এজন্যই আছে ডিপোজিট–লিমিট,
              সেশন–রিমাইন্ডার ও সেল্ফ–এক্সক্লুশন টুলস। প্রয়োজনে প্রফেশনাল রিসোর্সের লিংকও পাবেন।
              আমাদের কমিউনিটিকে সুরক্ষিত রাখা—এটাই আমাদের মিশনের কেন্দ্রে।
            </p>
            <div className="zHHBD-standard__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-standard__btn"
                title="এখনই নিরাপদে HHBD–এ যাত্রা শুরু করুন"
              >
                এখনই নিরাপদে HHBD–এ খেলুন
              </a>
            </div>
          </div>
          <figure className="zHHBD-standard__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD - বাংলাদেশে সুরক্ষিত ও লাইসেন্সধারী অনলাইন গেমিং"
            >
              <img
                src={a5}
                alt="সleek ডিসপ্লেতে জ্বলজ্বলে প্যাডলক, পাশে আত্মবিশ্বাসী প্লেয়ার — HHBD–এর সুরক্ষিত, লাইসেন্সধারী প্লের ভিজ্যুয়াল ইঙ্গিত।"
                title="HHBD - বাংলাদেশে সুরক্ষিত ও লাইসেন্সধারী অনলাইন গেমিং"
                className="zHHBD-standard__img"
              />
            </a>
          </figure>
        </div>
      </div>
    </section>

    <section className="zHHBD-faq" ref={faqRef}>
      <div className="zHHBD-faq__bg">
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
        <div className="zHHBD-faq__bubble"></div>
      </div>
      <div className="zHHBD-faq__container">
        <header className="zHHBD-faq__header">
          <h2 className="zHHBD-faq__title">
            HHBD: বাংলাদেশে প্রায় জিজ্ঞাসিত প্রশ্ন (FAQ)
          </h2>
        </header>
        <div className="zHHBD-faq__accordion">
          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">💲</i>
              বাংলাদেশে HHBD–এ খেলা কি নিরাপদ?
            </button>
            <div className="zHHBD-faq__a">
              নিশ্চিতভাবেই — আপনার সেফটি আমাদের প্রথম অগ্রাধিকার। HHBD ব্যক্তিগত ডাটা ও পেমেন্টে অ্যাডভান্সড SSL এনক্রিপশন ব্যবহার করে।
              আমরা কঠোর আন্তর্জাতিক স্ট্যান্ডার্ড মেনে চলি—প্রতিটি প্লেয়ারের জন্য সুরক্ষিত ও ফেয়ার পরিবেশ বজায় রাখতে।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">⏰</i>
              bKash বা Nagad দিয়ে কীভাবে ডিপোজিট করব?
            </button>
            <div className="zHHBD-faq__a">
              খুব দ্রুত ও সহজ। লগইন করুন, “Deposit”–এ যান, তারপর bKash বা Nagad নির্বাচন করুন।
              আপনি আমাদের অফিশিয়াল ওয়ালেট নম্বর ও একটি ইউনিক রেফারেন্স আইডি পাবেন।
              আপনার অ্যাপে ট্রান্সফার সম্পন্ন করলেই—ফান্ড প্রায় সঙ্গে–সঙ্গেই HHBD ব্যালেন্সে দেখা যায়।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🔒</i>
              জেতা অর্থ তুলতে কত সময় লাগে?
            </button>
            <div className="zHHBD-faq__a">
              আমরা দ্রুততা নিশ্চিত করি। bKash ও Nagad–এ পেআউট সাধারণত ১৫–৩০ মিনিটে সম্পন্ন হয়।
              আমাদের পেমেন্টস টিম স্পিডকে প্রাধান্য দেয়—যাতে আপনি দেরি ছাড়া অর্থ পেতে পারেন।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">📱</i>
              নতুন প্লেয়ার হিসেবে কী ধরনের বোনাস পাব?
            </button>
            <div className="zHHBD-faq__a">
              বাংলাদেশি নতুন প্লেয়াররা সাধারণত উদার ওয়েলকাম পান—অধিকাংশ সময় ম্যাচড ডিপোজিটের সাথে জনপ্রিয়{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লট</Link>{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>–এ ফ্রি স্পিন।
              আমাদের <Link to={getLangPath("/bonuses", lang)} className="rr555-aviatorlux__link">‘প্রোমোশন’</Link> পেজে নজর রাখুন—
              সাম্প্রতিক অফার ও সহজ শর্ত দেখার জন্য।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🎲</i>
              মোবাইলে কি HHBD–এর গেমস খেলতে পারব?
            </button>
            <div className="zHHBD-faq__a">
              অবশ্যই। HHBD সম্পূর্ণরূপে স্মার্টফোনের জন্য অপটিমাইজড।
              আমাদের সব{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link>, টেবিল{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> ও{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">লাইভ ক্যাসিনো</Link>—মোবাইল ব্রাউজার থেকেই খেলুন—অ্যাপের দরকার নেই।
              দ্রুত, ফ্লুইড, আর যেকোনো জায়গায় খেলার জন্য তৈরি।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">💬</i>
              HHBD–এর গেমস কি ফেয়ার?
            </button>
            <div className="zHHBD-faq__a">
              HHBD–এ ফেয়ারনেস মৌলিক বিষয়। সব{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> খ্যাতনামা প্রোভাইডার থেকে আসে
              এবং সার্টিফাইড RNG টেকনোলজি ব্যবহার করে—ফলাফল থাকে র‍্যান্ডম, নিরপেক্ষ ও ট্যাম্পার–প্রুফ।
            </div>
          </div>

          <div className="zHHBD-faq__item">
            <button className="zHHBD-faq__q" aria-expanded="false">
              <i className="zHHBD-faq__q-ico">🎯</i>
              সাহায্য বা সাপোর্ট দরকার হলে কী করব?
            </button>
            <div className="zHHBD-faq__a">
              আমাদের টিম ২৪/৭ উপলব্ধ। তাৎক্ষণিক সহায়তার জন্য লাইভ চ্যাট খুলুন, অথবা আমাদের ইমেইল করুন।
              বাংলা বা ইংরেজি—আপনার যেটি সুবিধাজনক, আমরা খুশিভাবেই সহায়তা করব।
            </div>
          </div>
        </div>
        <div className="zHHBD-faq__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-faq__btn"
            title="এখনই HHBD–এ যোগ দিন"
          >
            এখনই HHBD–এ যোগ দিন
          </a>
        </div>
      </div>
    </section>
  </>

      )}
    </>
  );
};

export default HomePage;
